<template>
  <div class="row">
    <div class="col-12">
      <h4>
        Modificar campos de lineas seleccionadas
      </h4>
      <hr class="w-100 my-2"/>
    </div>
    <div class="col-12 mb-2">
      <p class="text-xs font-weight-bold mb-0">
        Campo *
      </p>
      <multiselect 
        v-model="fieldSelected" 
        :options="fieldOptions" 
        label="name" 
        track-by="id"
        placeholder="Seleccionar Campo"
        :allowEmpty="false"
        :showLabels="false"
        @select="valueToChange = null"
        class="small-multiselect"
      />
    </div>
    <div class="col-12 mb-2">
      <p class="text-xs font-weight-bold mb-0">
        Valor *
      </p>
      <div v-if="fieldSelected">

        <!-- Text Input -->
        <base-input
          v-if="!['U_FollowUp','U_FechaConf','ShipDate','U_Real_Load_Date','WarehouseCode'].includes(fieldSelected.id)"
          v-model="valueToChange" 
          placeholder="Nuevo valor"
          class="m-0"
          inputClasses="input-group-alternative form-control-sm text-xs"
        />

        <!-- Select "Seguimiento"-->
        <multiselect 
          v-else-if="fieldSelected.id === 'U_FollowUp'"
          v-model="valueToChange" 
          :options="seguimientoOptions" 
          label="Description" 
          track-by="Value"
          placeholder="Nuevo valor"
          class="small-multiselect"
          :allowEmpty="false"
          :showLabels="false"
        />

        <!-- Select "Almacén"-->
        <multiselect 
          v-else-if="fieldSelected.id === 'WarehouseCode'"
          v-model="valueToChange" 
          :options="warehouses"
          placeholder="Nuevo valor"
          class="small-multiselect"
          :allowEmpty="false"
          :showLabels="false"
        />

        <!-- Date -->
        <flat-picker
          v-else-if="['U_FechaConf','ShipDate','U_Real_Load_Date'].includes(fieldSelected.id)"
          v-model="valueToChange"
          :config="{  }" 
          class="input-group-alternative form-control-sm text-xs datepicker m-0 w-100 " 
          style="cursor:pointer; outline:none;"
          placeholder="Nuevo valor"
        />
      </div>

    </div>

    <div class="col-12">
      <hr class="w-100 my-2"/>
      <div class="d-flex justify-content-end">
        <base-button 
          @click="$emit('close')"
          type="secondary"
        >
          Cancelar
        </base-button>
        <base-button 
          @click="
            $emit(
              'setFields', 
              fieldSelected.id, 
              fieldSelected.id === 'U_FollowUp' ? valueToChange.Value : valueToChange
            )
          "
          type="primary">
          Modificar campos
        </base-button>
      </div>
    </div>

  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import flatPicker from "vue-flatpickr-component";

  export default {
    name: 'SetFields',
    components: {
      Multiselect,
      flatPicker
    },
    props: {
      seguimientoOptions: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        fieldSelected: null,
        valueToChange: null,
        warehouses:[
          "AD-CUU",
          "AD-GDL",
          "AD-MTY",
          "AD-MEX",
          "AD-QRO",
          "AD-MID",
          "AD-EXT"
        ],
        fieldOptions: [
        {
          id: "ShipDate",
          name: "Fecha de Llegada",
        },
        {
          id: "U_TS_Marca",
          name: "Shipment ID",
        },
        {
          id: "U_FollowUp",
          name: "Seguimiento",
        },
        {
          id: "U_FechaConf",
          name: "Fecha de Confirmación",
        },
        {
          id: "FreeText",
          name: "Texto Libre",
        },
        {
          id: "U_PedimentNum",
          name: "Pedimento",
        },
        {
          id: "U_TrackingInfoPO",
          name: "Información de rastreo",
        },
        {
          id: "U_Issue_ValidatedComment",
          name: "CEDIS Destino",
        },
        {
          id: "U_Issue_ValidatedQty",
          name: "# ST",
        },
        {
          id: "U_Real_Load_Date",
          name: "Fecha Real",
        },
        {
          id: "WarehouseCode",
          name: "Almacén",
        },
        
      ],
      };
    },
    created() {
      this.fieldSelected = this.fieldOptions[0];
    }
  }
</script>

<style>
.flatpickr-input::placeholder {
  color: #adb5bd !important;
}
</style>